import React, { useState } from "react";
import { Link } from "react-router-dom";

const NavBar = () => {
  const [searchTerm, setSearchTerm] = useState("");

  // Your navigation links
 const navLinks = [
  { to: "/Ansys", label: "Ansys" },
  { to: "/Autocad", label: "Autocad" },
  { to: "/Catia", label: "Catia" },
  { to: "/Civil3d", label: "Civil3d" },
  { to: "/Etabs", label: "Etabs" },
  { to: "/Fusion", label: "Fusion" },
  { to: "/Google Sketchup", label: "Sketchup" },
  { to: "/Nx%20Cad", label: "NxCAD" },
  { to: "/Lumion", label: "Lumion" },
  { to: "/Revit Architecture", label: "Revit Architecture" },
  { to: "/Revit Structure", label: "Revit Structure" },
  { to: "/Staad Pro", label: "Staad Pro" },
  { to: "/Solidworks", label: "Solidworks" },
  { to: "/Civil3d", label: "3DS Max" },
  { to: "/civil-architecture", label: "BIM" },
  { to: "/civil-design", label: "Interior Design" },

  // IT COURSES
  { to: "/CProgramming", label: "C Programming" },
  { to: "/Accounting", label: "Accounting" },
  { to: "/GraphicDesign", label: "Graphic Design" },
  { to: "/DataVisualisation", label: "Data Visualisation" },
  { to: "/SoftwareTesting", label: "Software Testing" },
  { to: "/WebDevelopment", label: "Web Development" },
  { to: "/DatabaseManagement", label: "Database Management" },
  { to: "/UIUX", label: "UI & UX" },
  { to: "/PhotoShop", label: "PhotoShop" },
  { to: "/CorelDraw", label: "Corel Draw" },
  { to: "/Canva", label: "Canva" },
  { to: "/CSS", label: "CSS" },
  { to: "/Figma", label: "Figma" },
  { to: "/HTML5", label: "HTML 5" },
  { to: "/CppProgramming", label: "C++ Programming" },
  { to: "/CSharpProgramming", label: "C# Programming" },
];

  // Filtered links based on the search term
  const filteredLinks = navLinks.filter((link) =>
    link.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className=" header container-fluid topbar-top bg-warning">
      <div className="container">
        <div className="d-flex justify-content-between topbar py-2 px-5">
          <div className="d-flex align-items-center flex-shrink-0 topbar-info">
            <a
              href="#"
              className="me-4 text-secondary text-dark top"
              style={{ marginLeft: "-90px", fontSize: "15px" }}
            >
              <i
                className="fas fa-map-marker-alt me-2 text-dark text-bold top "
                style={{ marginTop: "-15px" }}
              ></i>
              <b> Kaniyapuram, Kerala</b>
            </a>
            <a
              href="#"
              className="me-4 text-secondary text-dark top"
              style={{ fontSize: "15px" }}
            >
              <b>
                {" "}
                <i className="fas fa-phone-alt me-2 text-dark"></i>+91
               8089657171
              </b>
              {/* <video src="img/call.mp4" width={80} height={50}>
                918089657171
              </video> */}
            </a>
            <a
              href="#"
              className="text-secondary text-dark top"
              style={{ fontSize: "15px" }}
            >
              <i className="fas fa-envelope me-2 text-dark"></i>
              <b>caddeskkaniyapuram@gmail.com</b>
            </a>
          </div>

          <nav>
            <div
              className="navbar navbar-light navbar-expand-lg top"
              style={{ marginLeft: "70px", marginTop: "-10px" }}
            >
              <div className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle bg-light text-dark"
                  data-bs-toggle="dropdown"
                  style={{
                    height: "40px",
                    borderRadius: "30px",
                    textAlign: "center",
                    padding: "0,10px",
                  }}
                >
                  Search Courses
                </Link>

                <div
                  className="dropdown-menu m-0 text-dark bg-warning text-bold bg-primary"
                  style={{
                    maxHeight: "200px",
                    // Adjust the max height as needed
                    overflowY: "auto",
                  }}
                >
                  <form className="px-1 py-1">
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        value={searchTerm}
                        style={{ width: "100px" }}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </form>

                  {filteredLinks.length > 0 ? (
                    filteredLinks.map((link, index) => (
                      <Link
                        key={index}
                        to={link.to}
                        className="nav-link nav-item text-dark py-1"
                      >
                        {link.label}
                      </Link>
                    ))
                  ) : (
                    <p className="dropdown-item text-muted">No results found</p>
                  )}
                </div>
              </div>
            </div>
          </nav>

          {/* <Link
            to="/Internship"
            className="  me-4 text-primary text-dark text-bold top"
            style={{ marginLeft: "00px" }}
          >
            <b> Internship</b>
          </Link>
          <div className="link-with-bar"></div>
          <Link
            to="/Placement"
            className="  me-4 text-primary text-dark text-bold top"
            style={{ marginLeft: "-80px" }}
          >
            <b>Placement</b>
          </Link> */}

          <div className=" d-flex align-items-center justify-content-center topbar-icon ">
            <a
              href="https://www.instagram.com/_caddesk_kaniyapuram_/?hl=en"
              className="me-4 "
              target="_blank"
            >
              {/* <i className="fab fa-facebook-f text-dark top"></i> */}
              <img
                src="img/insta.png"
                width={40}
                height={30}
                style={{ marginTop: "-23px" }}
              ></img>
            </a>

            <a
              href="https://www.facebook.com/people/Caddesk-kaniyapuram/61587576802972/"
              className="me-4"
              target="_blank"
            >
              {/* <i className="fab fa-instagram text-dark top"></i> */}
              <img
                src="img/facebook.png"
                width={40}
                height={30}
                style={{ marginTop: "-23px" }}
              ></img>
            </a>
          </div>
        </div>
      </div>{" "}
    </div>
  );
};
export default NavBar;
